import { makeAutoObservable } from 'mobx';
import submitLogin from './fn/submitLogin';

export default class LoginPageStore {
    username: string = '';
    password: string = '';
    loginErrorUserPwd: boolean = false;
    isLoggingIn: boolean = false;
    isRedirecting: boolean = false;
    errorContactInfo: {
        name: string;
        email: string;
        phone: string;
    } = {
        name: 'Kathrine Skau Sivertsen',
        email: 'kathrine.skau@coop.no',
        phone: '45231299',
    };

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.username = '';
        this.password = '';
        this.loginErrorUserPwd = false;
        this.isLoggingIn = false;
        this.isRedirecting = false;
    }

    setUsername = (value: string) => {
        this.username = value;
    };

    setPassword = (value: string) => {
        this.password = value;
    };

    setLoginErrorUserPwd = (value: boolean) => {
        this.loginErrorUserPwd = value;
    };

    setIsLoggingIn = (value: boolean) => {
        this.isLoggingIn = value;
    };

    setIsRedirecting = (value: boolean) => {
        this.isRedirecting = value;
    };

    submitLogin = submitLogin;
}
